var _style, _circle, _path, _g, _g2, _g3, _g4, _g5, _g6, _g7, _g8, _g9, _g10, _g11, _g12, _g13, _g14, _g15;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSifdOrangeIconBms(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 37.6 52.7",
    style: {
      enableBackground: "new 0 0 37.6 52.7"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:url(#XMLID_108_);stroke:url(#XMLID_109_);stroke-width:2;stroke-miterlimit:10;}\n\t.st1{fill:url(#XMLID_111_);stroke:url(#XMLID_112_);stroke-width:3;stroke-miterlimit:10;}\n")), /*#__PURE__*/React.createElement("linearGradient", {
    id: "XMLID_108_",
    gradientUnits: "userSpaceOnUse",
    x1: 104.5238,
    y1: 150.6609,
    x2: 157.2738,
    y2: 151.6609,
    gradientTransform: "matrix(-1.346900e-010 1 -1 -1.346900e-010 161.7608 -114.6389)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFF23A"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0401054,
    style: {
      stopColor: "#FEE62D"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1171,
    style: {
      stopColor: "#FED41A"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1964,
    style: {
      stopColor: "#FDC90F"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2809,
    style: {
      stopColor: "#FDC60B"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6685,
    style: {
      stopColor: "#F28F3F"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8876,
    style: {
      stopColor: "#ED693C"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#E83E39"
    }
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "XMLID_109_",
    gradientUnits: "userSpaceOnUse",
    x1: 120.1878,
    y1: 150.9579,
    x2: 129.6862,
    y2: 151.1379,
    gradientTransform: "matrix(-1.346900e-010 1 -1 -1.346900e-010 161.7608 -114.6389)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFF23A"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0401054,
    style: {
      stopColor: "#FEE62D"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1171,
    style: {
      stopColor: "#FED41A"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1964,
    style: {
      stopColor: "#FDC90F"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2809,
    style: {
      stopColor: "#FDC60B"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6685,
    style: {
      stopColor: "#F28F3F"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8876,
    style: {
      stopColor: "#ED693C"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#E83E39"
    }
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    id: "XMLID_330_",
    className: "st0",
    cx: 10.7,
    cy: 10.3,
    r: 3.8
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "XMLID_111_",
    gradientUnits: "userSpaceOnUse",
    x1: 107.5938,
    y1: 143.9241,
    x2: 192.4313,
    y2: 140.5456,
    gradientTransform: "matrix(-1.346900e-010 1 -1 -1.346900e-010 161.7608 -114.6389)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFF23A"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0401054,
    style: {
      stopColor: "#FEE62D"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1171,
    style: {
      stopColor: "#FED41A"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1964,
    style: {
      stopColor: "#FDC90F"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2809,
    style: {
      stopColor: "#FDC60B"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6685,
    style: {
      stopColor: "#F28F3F"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8876,
    style: {
      stopColor: "#ED693C"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#E83E39"
    }
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "XMLID_112_",
    gradientUnits: "userSpaceOnUse",
    x1: 119.6361,
    y1: 147.3509,
    x2: 164.7409,
    y2: 135.2651,
    gradientTransform: "matrix(-1.346900e-010 1 -1 -1.346900e-010 161.7608 -114.6389)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFF23A"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0401054,
    style: {
      stopColor: "#FEE62D"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1171,
    style: {
      stopColor: "#FED41A"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1964,
    style: {
      stopColor: "#FDC90F"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2809,
    style: {
      stopColor: "#FDC60B"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6685,
    style: {
      stopColor: "#F28F3F"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8876,
    style: {
      stopColor: "#ED693C"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#E83E39"
    }
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "XMLID_329_",
    className: "st1",
    d: "M30.6,45.6c2.8-2.8,4.2-6.7,4.2-11.7l0.2-9v-1.9c0-0.1,0-9.9-0.1-14.4 c-0.1-4.6-2.3-6.2-4.3-6.2c-2.2,0-3.1,0.6-5.8,7.8c-1.8,4.6-4.1,9.4-8.7,11.9C12,24.4,6.8,25,5.6,26.1c-0.6,0.6-2.8,1.4-2.4,7.8 c0.3,4,1.1,9,3.8,11.7c2.7,2.8,6.7,4.2,11.8,4.2C23.8,49.8,27.8,48.4,30.6,45.6z"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "XMLID_92_"
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "XMLID_93_"
  })), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    id: "XMLID_94_"
  })), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    id: "XMLID_95_"
  })), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    id: "XMLID_96_"
  })), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", {
    id: "XMLID_97_"
  })), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", {
    id: "XMLID_98_"
  })), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", {
    id: "XMLID_99_"
  })), _g9 || (_g9 = /*#__PURE__*/React.createElement("g", {
    id: "XMLID_100_"
  })), _g10 || (_g10 = /*#__PURE__*/React.createElement("g", {
    id: "XMLID_101_"
  })), _g11 || (_g11 = /*#__PURE__*/React.createElement("g", {
    id: "XMLID_102_"
  })), _g12 || (_g12 = /*#__PURE__*/React.createElement("g", {
    id: "XMLID_103_"
  })), _g13 || (_g13 = /*#__PURE__*/React.createElement("g", {
    id: "XMLID_104_"
  })), _g14 || (_g14 = /*#__PURE__*/React.createElement("g", {
    id: "XMLID_105_"
  })), _g15 || (_g15 = /*#__PURE__*/React.createElement("g", {
    id: "XMLID_106_"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSifdOrangeIconBms);
export default __webpack_public_path__ + "static/media/SIFD_Orange_icon_BMS.55dcc7a490022c95681c6aa96f735108.svg";
export { ForwardRef as ReactComponent };